import { createAsyncThunk } from '@reduxjs/toolkit';

import { scenarioApi, setScenario } from '../model';

export const getOfferDisbursementStepThunk = createAsyncThunk(
  'scenario/getOfferDisbursementStep',
  async (hashedDealId: string, { dispatch, rejectWithValue }) => {
    try {
      const offerDisbursementStep = await dispatch(
        scenarioApi.endpoints.getOfferDisbursementStep.initiate(hashedDealId),
      ).unwrap();

      if (!offerDisbursementStep?.content) {
        throw new Error('No content in offer disbursement step');
      }

      dispatch(setScenario(offerDisbursementStep));
      return offerDisbursementStep;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
